import { isIOS, isMobile } from 'react-device-detect';
/**
 * Checks for mobile PWA mode, which may not work on iOS.
 */
function isDegradedAndroidExperience() {
    if (!isMobile) {
        return false;
    }
    if (!window.matchMedia) {
        return false;
    }
    // check each of the modes that likely indicate "PWA mode":
    const pwaDisplayModes = ['fullscreen', 'standalone', 'minimal-ui'];
    const isPwaMode = pwaDisplayModes.some((pwaDisplayMode) => window.matchMedia(`(display-mode: ${pwaDisplayMode})`).matches);
    return !isPwaMode;
}
/**
 * Checks the iOS-exclusive property window.navigator.standalone to determine PWA mode.
 */
function isDegradedIOSExperience() {
    if (!isIOS) {
        return false;
    }
    const isPwaMode = !!(window.navigator && 'standalone' in window.navigator && window.navigator.standalone);
    return !isPwaMode;
}
export function isDegradedMobileExperience() {
    return isDegradedAndroidExperience() || isDegradedIOSExperience();
}
